/**
 * Query keys for Home (F46) — in their own module so every hook whose write
 * changes what Home shows (an invitation answered, a sponsorship offer
 * accepted) can refresh it without importing the Home hooks themselves.
 */
export const homeKeys = {
  all: ['home'] as const,
  summary: (journeyId: string | null) => [...homeKeys.all, 'summary', journeyId] as const,
};
